function ViewContents(props) {
  return <div className="container-fluid p-4">{props.children}</div>;
}

export default ViewContents;
